export default {
  app: {
    languagePopup: {
      title: '您当前使用的是 {logo} 的英文版本',
      subtitle: '您是否希望切换到首选语言？',
      cta: '切换到 {lang}',
    },
  },
};
